<bcb-generic-label [question]="question"></bcb-generic-label>
<div class="wallet-list">
	<div
		class="wallet-row"
		*ngFor="let row of rows.controls; let i = index"
		[formGroup]="$any(row)"
	>
		<mat-form-field appearance="outline" class="network-field">
			<mat-label>Network</mat-label>
			<mat-select
				formControlName="network"
				(valueChange)="onNetworkChange()"
				(blur)="touched()"
			>
				<mat-option
					*ngFor="let option of question.options"
					[value]="option.value"
				>
					{{ option.label }}
				</mat-option>
			</mat-select>
		</mat-form-field>

		<mat-form-field appearance="outline" class="address-field">
			<mat-label>Wallet address</mat-label>
			<input
				matInput
				formControlName="address"
				(blur)="onAddressBlur()"
			/>
		</mat-form-field>

		<button
			mat-icon-button
			type="button"
			class="remove-row"
			[disabled]="isDisabled"
			(click)="removeRow(i)"
			aria-label="Remove wallet address"
		>
			<mat-icon>delete</mat-icon>
		</button>
	</div>

	<button
		mat-stroked-button
		type="button"
		class="add-row"
		[disabled]="isDisabled"
		(click)="addRow()"
	>
		<mat-icon>add</mat-icon>
		Add wallet address
	</button>

	<mat-error *ngIf="formControl?.invalid && formControl?.touched">{{
		errorMessage
	}}</mat-error>
</div>
